import React from 'react';

const BillingGraceBanner = ({ gracePeriodEndsAt }) => {
    if (!gracePeriodEndsAt) return null;
    const end = new Date(gracePeriodEndsAt);
    const formatted = end.toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' });

    return (
        <div style={{
            background: '#FEF3C7',
            color: '#92400E',
            padding: '12px 20px',
            textAlign: 'center',
            fontWeight: 600,
            borderBottom: '1px solid #F59E0B',
        }}>
            Your last payment failed. Please update your payment method before {formatted} to avoid service interruption.
            {' '}
            <a href="/profile?tab=payment" style={{ color: '#92400E', textDecoration: 'underline' }}>
                Update payment method
            </a>
        </div>
    );
};

export default BillingGraceBanner;
